import React from 'react';

interface IPainNoshowProps {
  width?: number;
  height?: number;
}

export const PainNoshow: React.FC<IPainNoshowProps> = ({
  width = 48,
  height = 48,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="20" fill="#FFEDED" />
      <circle cx="17" cy="17" r="4" fill="#852525" opacity="0.3" />
      <circle cx="31" cy="17" r="4" fill="#852525" opacity="0.3" />
      <path
        d="M9 36C9 30 14 28 17 28C20 28 25 30 25 36"
        fill="#852525"
        opacity="0.3"
      />
      <path
        d="M23 36C23 30 28 28 31 28C34 28 39 30 39 36"
        fill="#852525"
        opacity="0.3"
      />
      <line
        x1="12"
        y1="12"
        x2="22"
        y2="22"
        stroke="#852525"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <line
        x1="22"
        y1="12"
        x2="12"
        y2="22"
        stroke="#852525"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <text
        x="17"
        y="44"
        fontFamily="FiraSans-SemiBold"
        fontSize="9"
        fill="#852525"
        textAnchor="middle"
      >
        -30%
      </text>
    </svg>
  );
};
